const DEFAULT_ACCOUNT_TYPE = '普通';


export default {
  DEFAULT_ACCOUNT_TYPE
};
